/**
 * いまどの園の画面を開いているか。
 *
 * サブドメインから決める。tagajo-spot.hoiku-station.com → 'tagajo'
 *
 * 🟥 園名は Supabase の gardens テーブルが正本。ここはその写し。
 *    2026-09-25 に突き合わせたところ、コード側の直書きが古く、
 *    sendai-izumi が「仙台泉」のままだった（正しくは「仙台泉中央」）。
 *    園名を足す・変えるときは、必ず gardens を先に直してからここを合わせる。
 * 🟥 同じ判定を各ページに書き写さない。ここ1つを使う。
 */

export const GARDEN_NAMES: Record<string, string> = {
  demo: 'きらり保育園デモ',
  kagano: 'きらり保育園かがの',
  minoh: 'きらり保育園箕面',
  sanuma: 'きらり保育園さぬま',
  'sendai-izumi': 'きらり保育園仙台泉中央',
  'sendai-rokuchome': 'きらり保育園仙台六丁の目',
  tagajo: 'きらり保育園多賀城',
};

export function getGardenSlug(): string {
  const m = window.location.hostname.match(/^(.+)-spot\./);
  return m ? m[1] : 'minoh';
}

export function getGardenName(slug = getGardenSlug()): string {
  return GARDEN_NAMES[slug] ?? 'きらり保育園';
}
